<template>
    <div class='element-container' data-content-type='element' :class="{'page-builder-mode' : page_builder_mode, 'remove-guides-mode': remove_guides}" :id='element.id' :element-type='element.element_type' :element-sequence-id='element.sequence_number' :style="element.compiled_styles">
        <slot></slot>
    </div>
</template>

<script>

export default {
    components: {},
    props:['element', 'page_builder_mode', 'remove_guides'],
}
</script>

<style lang="scss" scoped>
.element-container{
    flex-grow: 1;
    position: relative;
    width: 100%;
    box-sizing: border-box;
}

.element-container.page-builder-mode{
    display: flex;
    border: dashed 1px #1971c2;
    border-radius: 5px;
    height: auto;
    width: 100%;
    box-sizing: border-box;
    position: relative;
    flex-grow: 1;
}

.element-container.remove-guides-mode{
    border: none;
}
</style>